// Printable resources for Super Kids — vector coloring sheets, affirmation posters,
// lunchbox notes, and a gentle "real vs make-believe" conversation worksheet.
// Everything is generated live (SVG or print-ready HTML) so nothing can fail to load.

import { brandLineSVG, brandHTML } from "@/lib/brand";

const PAGE = 'width="816" height="1056" viewBox="0 0 816 1056"';
const FRAME = `
  <rect width="816" height="1056" fill="#FFFFFF"/>
  <rect x="24" y="24" width="768" height="1008" rx="18" fill="none" stroke="#D4AF37" stroke-width="3"/>
  <text x="408" y="1004" text-anchor="middle" font-family="monospace" font-size="13" fill="#8C6D23">I am a Super Kid  ·  Grown-up help: call or text 988</text>
  ${brandLineSVG(408, 1023)}
`;
const outlineTitle = (y, text, size = 54) =>
  `<text x="408" y="${y}" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-weight="800" font-size="${size}" fill="none" stroke="#1A1A1A" stroke-width="2.2" letter-spacing="2">${text}</text>`;

// ---------- Coloring sheets (black line-art kids can color) ----------
export const makeColoringSheet = (kind) => {
  const ink = 'fill="none" stroke="#1A1A1A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"';
  let art = "";

  if (kind === "superkid") {
    art = `
      ${outlineTitle(130, "I AM A SUPER KID")}
      <text x="408" y="175" text-anchor="middle" font-family="Georgia, serif" font-size="26" fill="#333">Color your super self!</text>
      <!-- cape -->
      <path d="M330 360 Q408 330 486 360 L545 720 Q408 650 271 720 Z" ${ink}/>
      <!-- head -->
      <circle cx="408" cy="330" r="72" ${ink}/>
      <circle cx="384" cy="322" r="7" fill="#1A1A1A"/><circle cx="432" cy="322" r="7" fill="#1A1A1A"/>
      <path d="M378 352 Q408 378 438 352" ${ink}/>
      <!-- body -->
      <path d="M360 402 Q408 430 456 402 L470 600 Q408 585 346 600 Z" ${ink}/>
      <!-- star badge -->
      <path d="M408 452 l14 30 33 4 -24 23 6 33 -29 -16 -29 16 6 -33 -24 -23 33 -4 Z" ${ink}/>
      <!-- arms up -->
      <path d="M360 430 Q300 400 300 340" ${ink}/><path d="M456 430 Q516 400 516 340" ${ink}/>
      <!-- legs -->
      <path d="M380 600 L372 720" ${ink}/><path d="M436 600 L444 720" ${ink}/>
      <!-- stars to color -->
      <path d="M180 500 l8 18 20 2 -15 14 4 20 -17 -10 -17 10 4 -20 -15 -14 20 -2 Z" ${ink}/>
      <path d="M620 520 l8 18 20 2 -15 14 4 20 -17 -10 -17 10 4 -20 -15 -14 20 -2 Z" ${ink}/>
      <path d="M210 760 l10 22 24 3 -18 17 5 24 -21 -12 -21 12 5 -24 -18 -17 24 -3 Z" ${ink}/>
      <path d="M600 770 l10 22 24 3 -18 17 5 24 -21 -12 -21 12 5 -24 -18 -17 24 -3 Z" ${ink}/>
      <text x="408" y="820" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-size="34" fill="none" stroke="#1A1A1A" stroke-width="1.5">BRAVE · KIND · STRONG</text>`;
  } else if (kind === "heart") {
    art = `
      ${outlineTitle(130, "MY BRAVE HEART")}
      <text x="408" y="175" text-anchor="middle" font-family="Georgia, serif" font-size="26" fill="#333">Fill me with your favorite colors.</text>
      <g transform="translate(408 500) scale(5)">
        <path d="M0 26 C -4 10 -34 8 -34 -14 C -34 -30 -16 -34 0 -16 C 16 -34 34 -30 34 -14 C 34 8 4 10 0 26 Z" ${ink}/>
      </g>
      <!-- rays -->
      ${Array.from({ length: 16 }).map((_, i) => { const a = (i / 16) * Math.PI * 2; return `<line x1="${408 + 210 * Math.cos(a)}" y1="${500 + 210 * Math.sin(a)}" x2="${408 + 245 * Math.cos(a)}" y2="${500 + 245 * Math.sin(a)}" ${ink}/>`; }).join("")}
      <!-- little hearts -->
      <g transform="translate(180 820) scale(1.6)"><path d="M0 8 C -2 2 -12 1 -12 -6 C -12 -12 -5 -13 0 -6 C 5 -13 12 -12 12 -6 C 12 1 2 2 0 8 Z" ${ink}/></g>
      <g transform="translate(636 820) scale(1.6)"><path d="M0 8 C -2 2 -12 1 -12 -6 C -12 -12 -5 -13 0 -6 C 5 -13 12 -12 12 -6 C 12 1 2 2 0 8 Z" ${ink}/></g>
      <text x="408" y="860" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-size="32" fill="none" stroke="#1A1A1A" stroke-width="1.5">I am loved.</text>`;
  } else {
    art = `
      ${outlineTitle(130, "SUNSHINE FEELINGS")}
      <text x="408" y="175" text-anchor="middle" font-family="Georgia, serif" font-size="26" fill="#333">Even cloudy days have sunshine behind them.</text>
      <!-- sun -->
      <circle cx="408" cy="470" r="150" ${ink}/>
      <circle cx="368" cy="440" r="10" fill="#1A1A1A"/><circle cx="448" cy="440" r="10" fill="#1A1A1A"/>
      <path d="M350 505 Q408 560 466 505" ${ink}/>
      ${Array.from({ length: 12 }).map((_, i) => { const a = (i / 12) * Math.PI * 2; return `<line x1="${408 + 165 * Math.cos(a)}" y1="${470 + 165 * Math.sin(a)}" x2="${408 + 215 * Math.cos(a)}" y2="${470 + 215 * Math.sin(a)}" ${ink}/>`; }).join("")}
      <!-- clouds -->
      <path d="M180 780 q0 -40 40 -40 q10 -34 50 -30 q34 -4 40 34 q36 0 36 36 Z" ${ink}/>
      <path d="M520 820 q0 -34 34 -34 q8 -28 44 -26 q30 -4 34 30 q30 0 30 30 Z" ${ink}/>
      <text x="408" y="900" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-size="30" fill="none" stroke="#1A1A1A" stroke-width="1.5">My feelings come and go, like weather.</text>`;
  }

  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" ${PAGE}>${FRAME}${art}</svg>`;
};

// ---------- "Why I Am a Super Kid" fill-in poster ----------
export const makeSuperKidPoster = () => {
  const gold = 'fill="#D4AF37"';
  const lines = (startY) => Array.from({ length: 3 }).map((_, i) => `<line x1="140" y1="${startY + i * 70}" x2="676" y2="${startY + i * 70}" stroke="#C9B37E" stroke-width="2" stroke-dasharray="2 6"/>`).join("");
  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" ${PAGE}>
  <rect width="816" height="1056" fill="#FFFFFF"/>
  <rect x="24" y="24" width="768" height="1008" rx="18" fill="#FFFFFF" stroke="#102A45" stroke-width="4"/>
  <rect x="38" y="38" width="740" height="980" rx="12" fill="none" stroke="#D4AF37" stroke-width="2"/>
  <text x="408" y="150" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-weight="800" font-size="46" fill="#102A45">WHY I AM A SUPER KID</text>
  <path d="M408 190 l16 34 38 5 -27 26 7 38 -34 -18 -34 18 7 -38 -27 -26 38 -5 Z" ${gold}/>
  <text x="408" y="300" text-anchor="middle" font-family="Georgia, serif" font-size="30" fill="#8C6D23" font-style="italic">I am brave. I am kind. I love myself. I matter.</text>
  <text x="140" y="390" font-family="Georgia, serif" font-size="26" fill="#102A45">My name is:</text>
  <line x1="320" y1="395" x2="676" y2="395" stroke="#C9B37E" stroke-width="2" stroke-dasharray="2 6"/>
  <text x="140" y="470" font-family="Georgia, serif" font-size="26" fill="#102A45">I am a super kid because...</text>
  ${lines(520)}
  <text x="140" y="780" font-family="Georgia, serif" font-size="26" fill="#102A45">One thing I love about myself:</text>
  ${lines(830)}
  <text x="408" y="988" text-anchor="middle" font-family="monospace" font-size="15" fill="#8C6D23">Color, sign, and hang me where you can see me!</text>
  ${brandLineSVG(408, 1010)}
</svg>`;
};

// ---------- Lunchbox / backpack love notes (cut-out cards) ----------
// ---------- Gentle "Real & Make-Believe" conversation worksheet (print-ready HTML) ----------
export const makeRealVsPretend = () => `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8"/>
<title>Real & Make-Believe — A Gentle Talk</title>
<style>
  @page { margin: 0.6in; }
  body { font-family: Georgia, 'Times New Roman', serif; color:#102A45; max-width: 760px; margin: 24px auto; padding: 0 24px; line-height: 1.6; }
  h1 { font-family: 'Cinzel', Georgia, serif; color:#0B192C; text-align:center; font-size: 30px; margin-bottom: 4px; }
  .sub { text-align:center; color:#8C6D23; font-style: italic; margin-top:0; }
  .grown { background:#F5F0E1; border:1px solid #D4AF37; border-radius:10px; padding:14px 18px; font-size: 14px; margin: 18px 0; }
  .card { border:1px solid #C9B37E; border-radius:12px; padding:16px 20px; margin:16px 0; }
  .card h2 { font-family:'Cinzel',Georgia,serif; color:#1E3E62; font-size:19px; margin:0 0 6px; }
  .line { border-bottom:2px dotted #C9B37E; height:26px; margin:10px 0; }
  .star { color:#D4AF37; }
  .footer { text-align:center; font-family: monospace; font-size:12px; color:#8C6D23; margin-top:26px; }
  ul { margin:6px 0; } li { margin:4px 0; }
  @media print { body { margin:0; } .noprint { display:none; } }
</style></head>
<body>
  <h1>Real &amp; Make-Believe</h1>
  <p class="sub">A gentle talk about pretend, real life, and big feelings</p>

  <div class="grown"><strong>For grown-ups:</strong> This sheet helps a child gently understand that make-believe is
  different from real life, and that all their feelings are welcome. Please go through it together, slowly, and follow
  your child's questions. Keep it warm, not scary. If big feelings come up, that's okay — it means they trust you.</div>

  <div class="card">
    <h2><span class="star">★</span> In games, cartoons &amp; stories…</h2>
    <ul>
      <li>Characters can get "hurt" and then pop right back up.</li>
      <li>You can press restart, get extra lives, or play again tomorrow.</li>
      <li>It is <strong>pretend</strong>. It is make-believe. It is not real.</li>
    </ul>
    <p>Draw or write one pretend thing you know is make-believe:</p>
    <div class="line"></div>
  </div>

  <div class="card">
    <h2><span class="star">★</span> In real life…</h2>
    <ul>
      <li>Our bodies are precious, and we each get just one.</li>
      <li>Sometimes a person gets very hurt or very sick, and their body stops working — this is called dying.</li>
      <li>When that happens in real life, there is no restart. They cannot come back, and that can make us very, very sad. That feeling is real, and it is okay.</li>
    </ul>
  </div>

  <div class="card">
    <h2><span class="star">★</span> Big feelings are always okay</h2>
    <p>It is okay to feel sad, confused, scared, or even angry. Talking about feelings makes them a little lighter.</p>
    <p>Right now, I feel:</p>
    <div class="line"></div>
  </div>

  <div class="card">
    <h2><span class="star">★</span> My safe grown-ups</h2>
    <p>Grown-ups I can always talk to when my heart feels heavy:</p>
    <div class="line"></div>
    <div class="line"></div>
    <p><strong>If I ever feel very unsafe or very sad, a grown-up can call or text <span class="star">988</span> for help, anytime.</strong></p>
  </div>

  <p style="text-align:center; font-family:'Cinzel',Georgia,serif; color:#1E3E62; font-size:18px;">
    I am real. I am loved. I matter — and so do the people around me.</p>

  <p class="footer">A gentle resource for Super Kids &amp; their grown-ups<br/>${brandHTML}</p>
  <p class="noprint" style="text-align:center;"><button onclick="window.print()" style="padding:10px 18px;border:none;border-radius:20px;background:#D4AF37;color:#0B192C;font-weight:bold;cursor:pointer;">Print this sheet</button></p>
</body></html>`;

// ---------- "I Am Enough" affirmation poster ----------
export const makeIAmEnoughPoster = () => {
  const gold = 'fill="#D4AF37"';
  const line = (y) => `<line x1="150" y1="${y}" x2="666" y2="${y}" stroke="#C9B37E" stroke-width="2" stroke-dasharray="2 6"/>`;
  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" ${PAGE}>
  <rect width="816" height="1056" fill="#FFFFFF"/>
  <rect x="24" y="24" width="768" height="1008" rx="18" fill="#FFFFFF" stroke="#102A45" stroke-width="4"/>
  <rect x="38" y="38" width="740" height="980" rx="12" fill="none" stroke="#D4AF37" stroke-width="2"/>
  <path d="M408 70 l18 38 42 6 -30 29 8 42 -38 -20 -38 20 8 -42 -30 -29 42 -6 Z" ${gold}/>
  <text x="408" y="250" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-weight="800" font-size="64" fill="#102A45">I AM ENOUGH</text>
  <text x="408" y="320" text-anchor="middle" font-family="Georgia, serif" font-size="30" fill="#8C6D23" font-style="italic">Just as I am, right now, I am enough.</text>
  <text x="408" y="420" text-anchor="middle" font-family="Georgia, serif" font-size="26" fill="#102A45">I don't have to be perfect to be loved.</text>
  <text x="408" y="465" text-anchor="middle" font-family="Georgia, serif" font-size="26" fill="#102A45">I am allowed to try, to rest, and to grow.</text>
  <text x="150" y="580" font-family="Georgia, serif" font-size="26" fill="#1E3E62">I am enough even when...</text>
  ${line(640)}${line(710)}${line(780)}
  <text x="150" y="860" font-family="Georgia, serif" font-size="26" fill="#1E3E62">Something I like about me:</text>
  ${line(920)}
  <text x="408" y="988" text-anchor="middle" font-family="monospace" font-size="15" fill="#8C6D23">Color me, sign me, and hang me up!</text>
  ${brandLineSVG(408, 1010)}
</svg>`;
};

// ---------- "My Calm-Down Steps" (print-ready HTML) ----------
export const makeCalmDownSteps = () => `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8"/>
<title>My Calm-Down Steps</title>
<style>
  @page { margin: 0.6in; }
  body { font-family: Georgia, serif; color:#102A45; max-width:760px; margin:24px auto; padding:0 24px; line-height:1.6; }
  h1 { font-family:'Cinzel',Georgia,serif; color:#0B192C; text-align:center; font-size:30px; margin-bottom:4px; }
  .sub { text-align:center; color:#8C6D23; font-style:italic; margin-top:0; }
  .step { display:flex; gap:16px; align-items:flex-start; border:1px solid #C9B37E; border-radius:12px; padding:14px 18px; margin:14px 0; }
  .num { flex:0 0 42px; height:42px; border-radius:50%; background:#D4AF37; color:#0B192C; font-weight:bold; font-family:'Cinzel',serif; display:flex; align-items:center; justify-content:center; font-size:22px; }
  .step h2 { font-family:'Cinzel',serif; color:#1E3E62; font-size:18px; margin:2px 0 4px; }
  .line { border-bottom:2px dotted #C9B37E; height:26px; margin:10px 0; }
  .footer { text-align:center; font-family:monospace; font-size:12px; color:#8C6D23; margin-top:24px; }
  .star{color:#D4AF37;} @media print { body{margin:0;} .noprint{display:none;} }
</style></head>
<body>
  <h1>My Calm-Down Steps</h1>
  <p class="sub">When big feelings get too big, I can do these, one at a time.</p>
  <div class="step"><div class="num">1</div><div><h2>Notice</h2>My body is telling me something — a tight tummy, hot face, or fast heartbeat. That's okay. It just means I have a big feeling.</div></div>
  <div class="step"><div class="num">2</div><div><h2>Breathe</h2>Balloon breaths: breathe in slowly (1-2-3-4), then out slowly (1-2-3-4). Do it 5 gentle times.</div></div>
  <div class="step"><div class="num">3</div><div><h2>Name it</h2>"Right now I feel ______." Naming a feeling helps make it smaller.</div></div>
  <div class="step"><div class="num">4</div><div><h2>Choose a calm tool</h2>Count to 10 · squeeze &amp; release my fists · sip some water · hug a stuffed animal · draw my feeling · stretch tall like a tree.</div></div>
  <div class="step"><div class="num">5</div><div><h2>Ask for help</h2>If the feeling stays big, I tell a safe grown-up. Asking for help is brave, not weak.</div></div>
  <p style="font-family:'Cinzel',serif;color:#1E3E62;">My top 3 calm-down tools:</p>
  <div class="line"></div><div class="line"></div><div class="line"></div>
  <p style="font-family:'Cinzel',serif;color:#1E3E62;">My safe grown-ups:</p>
  <div class="line"></div>
  <p><strong>If I ever feel very unsafe or very sad, a grown-up can call or text <span class="star">988</span>, anytime.</strong></p>
  <p class="footer">A gentle resource for Super Kids &amp; their grown-ups<br/>${brandHTML}</p>
  <p class="noprint" style="text-align:center;"><button onclick="window.print()" style="padding:10px 18px;border:none;border-radius:20px;background:#D4AF37;color:#0B192C;font-weight:bold;cursor:pointer;">Print this sheet</button></p>
</body></html>`;

// ---------- "My Circles of Trust" (SVG page) ----------
export const makeCirclesOfTrust = () => {
  const cx = 408, cy = 500;
  const label = (y, text, size, color, weight = "700") =>
    `<text x="${cx}" y="${y}" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-weight="${weight}" font-size="${size}" fill="${color}">${text}</text>`;
  const ex = (y, text) => `<text x="${cx}" y="${y}" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#1E3E62" font-style="italic">${text}</text>`;
  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" ${PAGE}>${FRAME}
  <text x="${cx}" y="95" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-weight="800" font-size="40" fill="#102A45">MY CIRCLES OF TRUST</text>
  <text x="${cx}" y="128" text-anchor="middle" font-family="Georgia, serif" font-size="18" fill="#8C6D23">Fill these in with a grown-up — decide together who belongs where.</text>
  <circle cx="${cx}" cy="${cy}" r="300" fill="#FFFFFF" stroke="#102A45" stroke-width="2.5"/>
  <circle cx="${cx}" cy="${cy}" r="200" fill="#FDFAF1" stroke="#D4AF37" stroke-width="2.5"/>
  <circle cx="${cx}" cy="${cy}" r="100" fill="#FBF3DA" stroke="#D4AF37" stroke-width="2.5"/>
  ${label(260, "PEOPLE I KNOW BY NAME", 20, "#102A45")}
  ${ex(284, "bus driver · a neighbor · someone new · people online")}
  ${label(360, "FRIENDS &amp; CLASSMATES", 20, "#1E3E62")}
  ${ex(384, "classmates · teammates · a kid from my class")}
  ${label(486, "CLOSEST &amp; SAFEST", 19, "#0B192C")}
  ${ex(510, "Mom · Dad · Grandma")}
  ${ex(532, "my best friend")}
  <!-- safe vs careful guide -->
  <rect x="48" y="822" width="720" height="168" rx="12" fill="#FFFFFF" stroke="#D4AF37" stroke-width="2"/>
  <text x="70" y="860" font-family="Cinzel, serif" font-weight="700" font-size="18" fill="#0E7490">A SAFE person...</text>
  <text x="70" y="886" font-family="Georgia, serif" font-size="15" fill="#102A45">· keeps their hands to themselves</text>
  <text x="70" y="910" font-family="Georgia, serif" font-size="15" fill="#102A45">· makes me feel calm and respected</text>
  <text x="70" y="934" font-family="Georgia, serif" font-size="15" fill="#102A45">· is okay when I say "no"</text>
  <text x="70" y="958" font-family="Georgia, serif" font-size="15" fill="#102A45">· never asks me to keep secrets from my</text>
  <text x="82" y="978" font-family="Georgia, serif" font-size="15" fill="#102A45">safe grown-ups</text>
  <text x="430" y="860" font-family="Cinzel, serif" font-weight="700" font-size="18" fill="#B45309">Be CAREFUL if someone...</text>
  <text x="430" y="886" font-family="Georgia, serif" font-size="15" fill="#102A45">· makes me feel scared or confused</text>
  <text x="430" y="910" font-family="Georgia, serif" font-size="15" fill="#102A45">· asks me to keep unsafe secrets</text>
  <text x="430" y="934" font-family="Georgia, serif" font-size="15" fill="#102A45">· doesn't listen when I say "no"</text>
  <text x="430" y="958" font-family="Georgia, serif" font-size="15" fill="#102A41">· dares me to do things I know are wrong</text>
  <text x="430" y="982" font-family="Georgia, serif" font-size="14" fill="#8C6D23">Tell a safe grown-up if this happens. · 988</text>
</svg>`;
};

// ---------- "A New School — Now What?" (print-ready HTML) ----------
export const makeNewSchool = () => `<!DOCTYPE html>
<html lang="en"><head><meta charset="UTF-8"/>
<title>A New School — Now What?</title>
<style>
  @page { margin: 0.6in; }
  body { font-family: Georgia, serif; color:#102A45; max-width:760px; margin:24px auto; padding:0 24px; line-height:1.6; }
  h1 { font-family:'Cinzel',Georgia,serif; color:#0B192C; text-align:center; font-size:28px; margin-bottom:4px; }
  .sub { text-align:center; color:#8C6D23; font-style:italic; margin-top:0; }
  .grown { background:#F5F0E1; border:1px solid #D4AF37; border-radius:10px; padding:12px 16px; font-size:13px; margin:16px 0; }
  .card { border:1px solid #C9B37E; border-radius:12px; padding:14px 18px; margin:14px 0; }
  .card h2 { font-family:'Cinzel',serif; color:#1E3E62; font-size:18px; margin:0 0 6px; }
  .line { border-bottom:2px dotted #C9B37E; height:26px; margin:10px 0; }
  .star{color:#D4AF37;} ul{margin:6px 0;} li{margin:4px 0;}
  .footer { text-align:center; font-family:monospace; font-size:12px; color:#8C6D23; margin-top:24px; }
  @media print { body{margin:0;} .noprint{display:none;} }
</style></head>
<body>
  <h1>A New School — Now What?</h1>
  <p class="sub">Starting fresh can feel exciting and scary at the same time. Both are okay.</p>
  <div class="grown"><strong>For grown-ups:</strong> A gentle guide to go through together before or during a school change —
  about choosing good friends, staying safe, and knowing when to speak up. Keep it warm and open, and let your child lead with questions.</div>

  <div class="card">
    <h2><span class="star">★</span> Do I know who my real friends are?</h2>
    A real friend is someone who:
    <ul>
      <li>is kind even when no one is watching</li>
      <li>is happy for me when good things happen</li>
      <li>says sorry and means it</li>
      <li>never asks me to be mean or to break rules</li>
      <li>makes me feel calm, not nervous</li>
    </ul>
    One person who feels like a real friend to me: <div class="line"></div>
  </div>

  <div class="card">
    <h2><span class="star">★</span> Why might a kid who makes bad choices want to be my friend first?</h2>
    When you're brand-new, kids who often get in trouble sometimes come to you first — because you don't know their
    reputation yet, and because you seem kind and easy to get along with. That doesn't mean you're bad at choosing friends!
    It just means you get to <strong>go slow</strong>. You can be friendly and polite to everyone, but you get to pick your
    <strong>close</strong> friends carefully, over time. You never have to be someone's close friend just because they
    picked you. Trust how your body feels around them: calm is a green light, nervous or confused is a "slow down."
  </div>

  <div class="card">
    <h2><span class="star">★</span> When should I tell an adult about a problem?</h2>
    Telling a grown-up is <em>not</em> tattling when safety is involved. Tell a safe adult right away if:
    <ul>
      <li>someone hurts you, or hurts another kid</li>
      <li>someone asks you to keep an <strong>unsafe</strong> secret</li>
      <li>someone is being bullied — including you</li>
      <li>someone dares or pressures you to break rules</li>
      <li>someone talks about hurting themselves or others</li>
      <li>anything gives you a yucky, scared, or confused feeling inside</li>
    </ul>
  </div>

  <div class="card">
    <h2><span class="star">★</span> My safe grown-ups at my new school</h2>
    <div class="line"></div><div class="line"></div>
    <p><strong>If I ever feel very unsafe or very sad, a grown-up can call or text <span class="star">988</span>, anytime.</strong></p>
  </div>

  <p style="text-align:center; font-family:'Cinzel',serif; color:#1E3E62; font-size:17px;">
    I can be kind to everyone — and still choose my friends wisely.</p>
  <p class="footer">A gentle resource for Super Kids &amp; their grown-ups<br/>${brandHTML}</p>
  <p class="noprint" style="text-align:center;"><button onclick="window.print()" style="padding:10px 18px;border:none;border-radius:20px;background:#D4AF37;color:#0B192C;font-weight:bold;cursor:pointer;">Print this sheet</button></p>
</body></html>`;
